export default "__VITE_ASSET__BWoOtoyL__"